import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { createReportAction } from '../../../redux/actions/orderActions'
import { clearErrors } from '../../../redux/actions/userActions.js'
import { useNavigate } from "react-router-dom"
import CustomSelect from '../../../elements/OptionWithSearch'
import { GetReportOptions } from './ReportOptions'
import Loader from '../../loader/loader.jsx'

const OrderForm = ({ order }) => {





    const navigate = useNavigate()

    const dispatch = useDispatch()
    const { user } = useSelector((state) => state.verifyEmailStore)
    const { loading, error, message } = useSelector((state) => state.createReport)




    const [report_type, setReport_type] = useState('')
    const [report_reason, setReport_reason] = useState('')

    const [options, setOptions] = useState([])



    useEffect(() => {
        if (order && user) {

            const dynamicOptions = GetReportOptions(order, user);
            setOptions(dynamicOptions);
        }



    }, [order, user]);



    const displayID = String((order?.id)).padStart(6, '0');



    const handleSubmit = (e) => {
        e.preventDefault();


        const myform = new FormData()


        myform.append("report_type", report_type)
        myform.append("report_reason", report_reason)
        myform.append("order_id", order.id)



        dispatch(createReportAction(myform))

    }

    const handleReset = () => {
        setReport_type('')
        setReport_reason('')


    }



    useEffect(() => {
        if (error) {
            toast.error(error)
            dispatch(clearErrors())
        }

        if (message) {
            toast.success(message)
            dispatch({ type: "CREATE_REPORT_RESET" })
            navigate("/orders/all-orders")
        }



    }, [navigate, dispatch, error, message]);




    return (
        <Fragment>
            {loading && <Loader/>}
            <form action="" className="w-full max-w-2xl bg-white p-8 rounded-2xl shadow-xl shadow-zinc-100/50 border border-zinc-100 flex flex-col gap-6" onSubmit={handleSubmit}>
                
                {/* Info Cards */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div className="bg-blue-50/50 p-4 rounded-xl border border-blue-100">
                        <span className='text-xs font-bold text-blue-600 uppercase tracking-wider'>Order ID</span>
                        <p className='text-lg font-bold text-blue-900 mt-1'>{displayID}</p>
                    </div>
                    <div className="bg-zinc-50 p-4 rounded-xl border border-zinc-200">
                        <span className='text-xs font-bold text-zinc-500 uppercase tracking-wider'>Current Status</span>
                        <p className='text-lg font-bold text-zinc-800 mt-1'>{order?.status}</p>
                    </div>
                </div>

                {/* Dropdown */}
                <div className='flex flex-col w-full relative'>
                    <label className='text-sm font-bold text-zinc-700 mb-2'>Select the issue <span className='text-red-500'>*</span></label>
                    {options?.length > 0 &&
                        <CustomSelect
                            options={options}
                            value={report_type}
                            onChange={setReport_type}
                            placeholder="Select Report type"
                            name="country"
                            classes="px-4 py-3 rounded-xl outline-none focus:ring-2 focus:ring-indigo-500 text-sm font-medium bg-zinc-50 border border-zinc-200 hover:border-zinc-300 transition-all"
                        />
                    }
                </div>

                {/* Textarea */}
                <div className='flex flex-col w-full'>
                    <label className='text-sm font-bold text-zinc-700 mb-2'>Describe the issue <span className='text-red-500'>*</span></label>
                    <textarea 
                        name="" 
                        id="" 
                        rows={`6`} 
                        placeholder='Please describe the issue in detail...'
                        className='px-4 py-3 rounded-xl outline-none focus:ring-2 focus:ring-indigo-500 text-sm font-medium bg-zinc-50 border border-zinc-200 hover:border-zinc-300 transition-all resize-none' 
                        value={report_reason} 
                        onChange={(e) => setReport_reason(e.target.value)}
                    >
                    </textarea>
                </div>

                {/* Buttons */}
                <div className="flex justify-end items-center gap-3 mt-4">
                    <button 
                        className="text-zinc-600 font-semibold py-3 px-6 rounded-xl border border-zinc-200 hover:bg-zinc-50 transition-all active:scale-[0.98]" 
                        onClick={handleReset} 
                        type='button'
                    >
                        Reset
                    </button>
                    <button 
                        className="bg-gradient-to-r from-indigo-600 to-indigo-700 text-white font-semibold py-3 px-8 rounded-xl hover:shadow-lg hover:shadow-indigo-100 transition-all active:scale-[0.98]" 
                        type='submit'
                    >
                        Submit Report
                    </button>
                </div>

            </form>
        </Fragment>
    )
}

export default OrderForm